import React from 'react';
import { alpha, Box } from '@mui/material';
import { ReportWhy } from 'app/concierge/types';

interface IProps {
    why?: ReportWhy | null;
    elementId: number;
}

/**
 * Why a report row is in the answer, as one muted line under the report title (Marius,
 * 2026-09-09, option 1 for the duplicate info icons): the summary sentence as the server wrote
 * it, in the panel's secondary text style. Nothing while the summary is still preparing and
 * nothing when the row carries no why, so an older payload renders exactly as today.
 */
export default function ReportWhyLine({ why, elementId }: IProps) {
    const text = typeof why?.text === 'string' ? why.text.trim() : '';

    if ('' === text) {
        return null;
    }

    return (
        <Box
            data-test={`report-why-line-${elementId}`}
            sx={{
                paddingLeft: '24px',
                fontSize: '12px',
                lineHeight: '18px',
                color: (theme) => alpha(theme.palette.text.primary, 0.64),
            }}
        >
            {text}
        </Box>
    );
}
